import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { fieldInputCls } from "@/components/Field";
import { useT } from "@/lib/i18n";

export const TagInput = ({ values, onChange, suggestions = [], testid }) => {
  const { t } = useT();
  const [text, setText] = useState("");
  const add = () => {
    const v = text.trim();
    if (v && !values.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...values, v]);
    setText("");
  };
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add();
    }
  };
  return (
    <div data-testid={testid} className="space-y-2">
      <Input data-testid={`${testid}-input`} value={text} placeholder={t("tag_hint")} list={`${testid}-list`}
        onChange={(e) => setText(e.target.value)} onKeyDown={onKey} onBlur={add} className={fieldInputCls} />
      <datalist id={`${testid}-list`}>{suggestions.filter((s) => !values.includes(s)).map((s) => <option key={s} value={s} />)}</datalist>
      {values.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {values.map((v) => (
            <span key={v} data-testid={`${testid}-tag-${v}`} className="flex items-center gap-1 bg-[#181B26] border border-[#282D3D] rounded-sm pl-2 pr-1 py-0.5 font-mono text-xs">
              {v}
              <button type="button" data-testid={`${testid}-remove-${v}`} onClick={() => onChange(values.filter((x) => x !== v))}
                className="p-0.5 text-slate-500 hover:text-[#FF3B30] transition-colors duration-200"><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
